<template>
    <div class="ts-space is-big"></div>
    <div class="ts-divider"></div>
    <div class="ts-content is-vertically-very-padded" style="background: var(--ts-gray-50)">
        <div class="ts-container">
            <div class="ts-header is-large is-heavy">Tabs Unloader</div>
            <div class="ts-text is-secondary">Made by <a href="https://github.com/sakkyoi" target="_blank">sakyoi</a> with love. Tabs Unloader is opensource on <a href="https://github.com/sakkyoi/Tabs-Unloader" target="_blank"><span class="ts-icon is-github-icon"></span> Github</a> with <router-link to="/license" class="ts-text is-" target="_blank">LGPL-3.0 license</router-link>.</div>
            <div class="ts-text is-secondary">This site designed by <a href="https://v4.tocas-ui.com/" class="ts-text is-external-link" target="_blank">Tocas-UI</a>. Tabs Unloader also designed by Tocas-UI.</div>
            <div class="ts-space"></div>
            <div class="ts-header is-small is-heavy">Analytics</div>
            <div class="ts-text is-secondary">
                We are aggregating and analyzing the actions you take here by our own analytics server. You can choose to prevent that. Doing so will protect your privacy, but will also prevent us from learning from your actions and creating a better experience for your and other users.
                <label class="ts-checkbox">
                    <input type="checkbox" :checked="isOpted" @change="opted">
                    <span>{{ optMsg }}</span>
                </label>
            </div>
            <div class="ts-space"></div>
            <div class="ts-text is-secondary"><a href="https://github.com/sakkyoi" target="_blank">Author</a> | <a href="https://github.com/sakkyoi/Tabs-Unloader" target="_blank">Github</a> | <router-link to="/license" class="ts-text is-" target="_blank">License</router-link> | <router-link to="/privacy" class="ts-text is-" target="_blank">Privacy Policy</router-link> | <a href="https://v4.tocas-ui.com/" class="ts-text is-external-link" target="_blank">Tocas-UI</a></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageFooter',
    methods: {
        opted() {
            var _paq = window._paq = window._paq || [];
            if (!this.isOpted) {
                this.optMsg = 'You are not opted out. Uncheck this box to opt-out.';
                _paq.push(['forgetUserOptOut']);
            } else {
                this.optMsg = 'You are currently opted out. Check this box to opt-in.';
                _paq.push(['optUserOut']);
            }
        }
    },
    data() {
        return {
            idOpted: false,
            optMsg: ''
        }
    },
    mounted() {
        var _paq = window._paq = window._paq || [];
        const oldThis = this;
        _paq.push([function () {
            if (!this.isUserOptedOut()) {
                oldThis.optMsg = 'You are not opted out. Uncheck this box to opt-out.';
                oldThis.isOpted = true;
            } else {
                oldThis.optMsg = 'You are currently opted out. Check this box to opt-in.';
                oldThis.isOpted = false;
            }
        }])
    }
}
</script>
